fragment chainMembershipFields on ChainMembership {
  id
  owningBranchId
  name
  frequency
  interval
  recurringFee {
    amount
    currency
  }
  benefitAmount {
    amount
    currency
  }
  signupFee {
    amount
    currency
  }
  applicableServiceCategoryIds
  applicableServiceIds
  applicablePackageIds
  applicableBrandIds
  applicableProductIds
  creditAppliesToAllProducts
  creditAppliesToAllServices
  type
  lifetimeBillingCycles
  canBePurchasedOnline
  canBeCancelledOnline
  onlineName
  onlineDescription
  termsEnabled
  terms {
    text
  }
  benefits {
    ... on MembershipServiceDiscountBenefit {
      id
      rate
      usableOnlyAfterCreditWasSpent
      discountAppliesToAllServices
      applicableServiceCategoryIds
      applicableServiceIds
      applicablePackageIds
    }
    ... on MembershipRetailDiscountBenefit {
      id
      rate
      usableOnlyAfterCreditWasSpent
      discountAppliesToAllProducts
      applicableBrandIds
      applicableProductIds
    }
    ... on MembershipRecurringServiceBenefit {
      id
      quota
      renewalBillingCycles
      unlimited
      applicableServiceCategoryIds
      applicableServiceIds
      applicablePackageIds
      applicableServices {
        id
        name
      }
      inUse
    }
    ... on MembershipCustomBenefit {
      id
      text
    }
    __typename
  }
}
